var exports = {
  "zr": "DamaBoard.module__root___S1Jud1",
  "no": "DamaBoard.module__board___S1Jud1",
  "Ew": "DamaBoard.module__square___S1Jud1",
  "BB": "DamaBoard.module__light___S1Jud1",
  "XT": "DamaBoard.module__dark___S1Jud1",
  "fV": "DamaBoard.module__piece___S1Jud1",
  "f0": "DamaBoard.module__paths___S1Jud1",
  "r2": "DamaBoard.module__pathsLabel___S1Jud1",
  "Ae": "DamaBoard.module__path___S1Jud1",
  "z3": "DamaBoard.module__error___S1Jud1",
};

module.exports = exports;
